import React from "react";
import { useCurrency } from "@/context/CurrencyContext";

/**
 * <Money amount={100} from="EUR" />
 * Affiche un montant converti dans la devise courante avec tooltip du montant d'origine.
 * v2.0.11 — Choix user 3b/5a : conversion pour affichage, montant original conservé en DB.
 */
export function Money({ amount, from = "EUR", showOriginal = true, className = "", testid }) {
  const { currency, format, convert } = useCurrency();
  if (amount == null || amount === "") return null;
  const formatted = format(amount, from);
  const sameCurrency = currency === from;
  const title = !sameCurrency && showOriginal
    ? `Montant d'origine : ${new Intl.NumberFormat("fr-FR", { style: "currency", currency: from, maximumFractionDigits: 0 }).format(Number(amount))}`
    : undefined;
  return (
    <span className={className} title={title} data-testid={testid}>
      {formatted}
      {!sameCurrency && showOriginal && (
        <span className="ml-1 text-[9px] opacity-50 align-super">≈</span>
      )}
    </span>
  );
}

export default Money;
